import type { SxProps, Theme } from '@mui/material/styles'

/**
 * Instrument workspace pages (question builder, routing) — Figma `5062:8528` / `4398:5113`.
 * Header toolbar (`5037:6405`) and page body share the same horizontal rail so back, title,
 * and “Routing & Logic” align at **32dp** on 1080p (content column ≈1664px; max **1760px** centered on wider viewports).
 */
export const INSTRUMENT_WORKSPACE_PAGE_MAX_WIDTH_PX = 1760

/** Figma `4687:4608` / `I5037:6405;57:2014` — 32dp horizontal gutter. */
export const INSTRUMENT_WORKSPACE_GUTTER_PX = 32

export const INSTRUMENT_WORKSPACE_BOTTOM_GUTTER_PX = INSTRUMENT_WORKSPACE_GUTTER_PX

/** Figma `5037:6411` — back icon left inset (29dp); aligns with page breadcrumb rail (`4398:5120` @ 32dp). */
export const INSTRUMENT_HEADER_BACK_LEFT_PX = 29

/** Gap between header back control and instrument title (`5037:6411` → `5037:6410`). */
export const INSTRUMENT_HEADER_BACK_TITLE_GAP_PX = 10

/** Figma `4398:5117` / `5037:6410` — Head_bold_24 in app header. */
export const INSTRUMENT_HEADER_TITLE_TYPOGRAPHY_SX = {
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '32px',
  letterSpacing: '0.0703px',
} as const

/** Back hit target — icon centered; `ml` nudges left so glyph lines up with 32dp page text. */
export function instrumentHeaderBackButtonSx(): SxProps<Theme> {
  return {
    width: 36,
    height: 44,
    borderRadius: '10px',
    flexShrink: 0,
    p: 0,
    ml: `${INSTRUMENT_HEADER_BACK_LEFT_PX - INSTRUMENT_WORKSPACE_GUTTER_PX}px`,
    color: '#0f172a',
    '&:hover': { bgcolor: 'rgba(15, 23, 42, 0.04)' },
  }
}

/** Shared max-width + horizontal inset for AppShell header rail and workspace inner shell. */
export function instrumentWorkspaceRailBoxSx(
  maxWidth: number = INSTRUMENT_WORKSPACE_PAGE_MAX_WIDTH_PX,
): SxProps<Theme> {
  return {
    boxSizing: 'border-box',
    maxWidth,
    mx: 'auto',
    width: '100%',
    minWidth: 0,
    pl: `${INSTRUMENT_WORKSPACE_GUTTER_PX}px`,
    pr: `${INSTRUMENT_WORKSPACE_GUTTER_PX}px`,
  }
}
